<div role="main" class="fc-page">
  <app-header></app-header>

  <section class="fc-panel confirmation-panel">
    <div class="fc-panel-body confirmation-body">
      <h2 class="confirmation-title">Submission Complete</h2>
      <p class="confirmation-subtitle">Your document(s)/correspondence has been successfully submitted.</p>

      <div class="confirmation-card">
        @if (confirmationMessage) {
          <div class="configured-message" [innerHTML]="confirmationMessage"></div>
        }

        <div class="submission-details">
          <div class="submission-details-header">SUBMISSION DETAILS</div>
          <div class="detail-row">
            <span class="detail-label">Date Submitted</span>
            <span class="detail-value">{{ date | date: 'MMMM d, yyyy' }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Reference ID</span>
            <span class="detail-value">{{ referenceId }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Files Submitted</span>
            <span class="detail-value">{{ fileCount }} {{ fileCount === 1 ? 'file' : 'files' }}</span>
          </div>
          <div class="detail-row-full">
            An email confirmation was sent to {{ email }}
          </div>
        </div>
      </div>

      <p class="confirmation-instructions">Please close this browser or to repeat this process again with the same or a new reference ID, click the &ldquo;Enter New Reference ID&rdquo; button below.</p>
    </div><!-- end fc-panel-body -->

    <div class="fc-panel-footer">
      <button type="button" class="btn-enter" id="dashboardButton" ngbTooltip="Return to main page to enter a new reference ID." (click)="exit()">Enter New Reference ID</button>
    </div>
  </section>

  <app-footer [positionFixed]="false"></app-footer>
</div>
